<template>
  <b-badge
    v-if="status"
    pill
    :variant="`neutral-${statusVariant}`"
    :class="`${statusClass} text-${statusVariant} text__${statusClass} rounded-0`"
  >
    {{ status.name }}
    <span v-if="isOwner">({{ reviewPendingCount }})</span>
  </b-badge>
</template>

<script>
import Status from '@/models/Status';

export default {
  name: 'BaseTagSubmissionStatus',

  props: {
    status: {
      type: Status,
      default: null
    },
    reviewPendingCount: {
      type: Number,
      default: 0
    },
    isOwner: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    statusVariant() {
      if (this.status.isNotSubmitted || this.status.isNotYet) {
        return 'danger';
      }
      if (this.status.isReviewPending) {
        return 'warning';
      }
      if (this.status.isFeedback) {
        return 'info';
      }
      if (this.status.isPassed) {
        return 'success';
      }
      if (this.status.isNotYet) {
        return 'danger';
      }

      return '';
    },

    statusClass() {
      let statusClass = 'tag__submission-status';

      if (this.status.isNotSubmitted) {
        statusClass += ' tag--not-submitted';
      }
      if (this.status.isReviewPending) {
        statusClass += ' tag--review-pending';
      }
      if (this.status.isFeedback) {
        statusClass += ' tag--feedback';
      }
      if (this.status.isPassed) {
        statusClass += ' tag--passed';
      }
      if (this.status.isNotYet) {
        statusClass += ' tag--not-yet';
      }

      return statusClass;
    }
  }
};
</script>
